import {
  Input,
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Output,
  EventEmitter,
  OnDestroy,
  HostListener,
  SimpleChanges,
  NgZone,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { OrdersWithPayment, Order, Modifier, BotOrder, CardDetails, ModifierOption, cardBrandIcon } from 'src/app/models/order';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from 'src/app/order.service';
import { Store } from 'src/app/models/store';
import { PaymentMethodsBottomSheetComponent } from '../payment-methods-bottom-sheet/payment-methods-bottom-sheet-component';
import * as moment from 'moment';
import { BehaviorSubject, forkJoin, Observable, of, Subject, Subscription, timer } from 'rxjs';
import { OrderHelpers } from '../utils/helpers';
import { MyErrorStateMatcher } from 'src/app/_helpers/error-matcher';
import { BooleanService, Flag } from 'src/app/_services/boolean.service';
import { PaymentOptionService, PaymentOption } from 'src/app/_services/payment-option.service';
import { OccasionDetailService } from 'src/app/_services/occasion-detail.service';
import { catchError, debounceTime, first, switchMap, takeUntil } from 'rxjs/operators';
import { ArrivedDialogComponent } from 'src/app/arrived-dialog/arrived-dialog.component';
import { DEVICE_TOKEN_KEY } from '../../_helpers/auth.interceptor';
import { Constants } from 'src/app/constants';
import { ComponentCanDeactivate } from 'src/app/_helpers/pending-changes-gaurd';
import {WalletComponent} from '../wallet/wallet.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {PaymentGatewayService} from '../../_services/payment-gateway.service';
import {WorldnetDialogComponent} from '../../worldnet-dialog/worldnet-dialog.component';
import {OrderProcessingService} from '../../_services/order-processing.service';
import {ScheduleOrderDialogComponent} from "../schedule-order-dialog/schedule-order-dialog.component";
import {ScheduleBottomSheetComponent} from "../schedule-bottom-sheet/schedule-bottom-sheet-component";
import { get } from 'scriptjs';
import {CvvDialogComponent} from '../cvv-dialog/cvv-dialog.component';
import {ThreeDSResponse} from '../../models/threeds';
import {ThreedsCheckComponent} from '../threeds-check/threeds-check.component';
import {data} from 'autoprefixer';
import {AnalyticsService} from '../../_services/analytics.service';

declare var Gateway;

@Component({
  selector: 'app-order-summary-master',
  templateUrl: './order-summary-master.component.html',
  styleUrls: ['./order-summary-master.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderSummaryMasterComponent implements OnInit, OnDestroy, ComponentCanDeactivate{
  /** Brand icon for a saved card; falls back to a generic card when the gateway's `card_type` has no artwork. */
  readonly cardBrandIcon = cardBrandIcon;


  @Input() store:Store;
  orderHash:string
  orderWithPayment:OrdersWithPayment;
  phoneNumber:string;
  isLoading = true
  orderInstruction:string;
  guestCardDetails:CardDetails[];
  // preferredPaymentCash:boolean;
  // preferredPaymentStoreCredit:boolean;
  // preferredCard:CardDetails;
  otpSent:boolean = false;
  otpSending:boolean = false;
  /** ENG-5609: guest is checking out without a verified number, paying by card only. */
  guestCheckout:boolean = false;
  otp: string;
  /** Seconds until "Resend" is allowed again; 0 = allowed. */
  resendCooldown = 0;
  static readonly RESEND_COOLDOWN_S = 30;
  private resendTimer: any = null;
  /** Aborts an in-flight WebOTP (SMS autofill) request. */
  /** `?openWallet=1` (from the failure page's "try a different card") opens the wallet once loaded. */
  private autoOpenWalletRequested = false;
  storeId:string;
  paymentGateway;
  storeCredit = 0;
  isSubmitted:boolean = false;
  orderName:string;
  optIn:boolean = true;
  position: string = "34px";
  errorMatcher = new MyErrorStateMatcher();
  openScheduleOnInit = false;
  isPosOnline: string;
  tableSideTab = 'OPENTAB';
  paymentOption:PaymentOption;
  isAdmin:boolean;

  promoConditionsMet=true;
  sliderValue: number = 50;
  isSubmitting = false;

  // ENG-5252: pre-submit hold (customer cancellation setting)
  submitHoldActive = false;
  submitHoldSeconds = 0;
  private submitHoldInterval: any;
  private pendingHoldFutureOrder = false;
  isVerifyingCard = false;
  showBillingAddressForm = false;
  billingStreet = '';
  billingCity = '';
  billingZip = '';
  addressError = '';
  uiSetting:any;
  //static message when store is closed
  displayStoreCloseMsg = `Can not submit order as your current time/timezone is outside of the merchant’s operating hours. Please review merchant’s local timezone operating hours and resubmit.`
  private paymentObs:Subscription;
  private occasionObs:Subscription;
  occasionDetail;
  futureOccasionSelected = false;
  private orderSubmitSubject = new BehaviorSubject<string>('');
  private orderSubmitSub: Subscription;
  private inputRange: HTMLInputElement;
  private maxValue: number = 100;
  private speed: number = 12;
  private currValue: number;
  private rafID: number;
  inputID: any;
  private destroySubject: Subject<void> = new Subject();
  private refreshSubject: Subject<void> = new Subject();

  cvv:string;
  threeDS: any;
  tdsResponse: ThreeDSResponse;

  @HostListener('window:unload')
  unloadHandler() {
    localStorage.removeItem('menu_group_name');
    localStorage.removeItem('menu_sub_group_name');
  }
  /** Set while we deliberately send the browser to the gateway's hosted payment page. */
  private leavingForPaymentPage = false;

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away
    //
    // The hosted-page redirect sets isSubmitting before form.submit(), so leaving for Worldnet
    // tripped this guard and the browser asked "Changes that you made may not be saved" on the
    // way to the payment page. That navigation is the intended next step, not a lost edit.
    return this.leavingForPaymentPage || !this.isSubmitting;
  }

  constructor(
    private route: ActivatedRoute,
    private orderService:OrderService,
    private router: Router,
    private bottomSheet: MatBottomSheet,
    private snackBar: MatSnackBar,
    private boolService:BooleanService,
    private paymentOptionService: PaymentOptionService,
    private occasionDetailService: OccasionDetailService,
    private dialog: MatDialog,
    private paymentGatewayService: PaymentGatewayService,
    private ngZone: NgZone,
    private orderProcessingService: OrderProcessingService,
    private cdr: ChangeDetectorRef,
    private analyticsService: AnalyticsService
  ) {
    // Set up once (ngOnInit runs again on every refresh): see OrderService.itemsChanged.
    this.orderService.itemsChanged.pipe(takeUntil(this.destroySubject)).subscribe(hash => {
      if (!hash || hash === this.orderHash) this.refresh(null);
    });
  }

  refresh(occasionDetail){
    this.ngOnInit()
  }

  /** Refresh order data after tip change without resetting schedule/occasion state */
  onTipRefresh() {
    this.orderService.getOrder(this.orderHash, this.isPosOnline).subscribe(data => {
      this.orderWithPayment = Object.assign(new OrdersWithPayment(), data, {
        bot_order: Object.assign(new BotOrder(), data.bot_order, {
          occasion_schedule: data.bot_order.occasion_schedule
            ? moment(data.bot_order.occasion_schedule, 'hh:mm A MMM DD, YYYY').toDate()
            : null
        }),
        items: data.items.map(o => Object.assign(new Order(), o, {
          modifiers: o.modifiers.map(x => Object.assign(new Modifier(), x))
        })),
        store: Object.assign(new Store(), data.store),
        payment: OrderHelpers.parsePayment(data.payment)
      });
      this.store = this.orderWithPayment.store;
      this.cdr.markForCheck();
    });
  }

  getStoreId(){
    return this.orderWithPayment.bot_order.store;
  }

  getPlainPhoneNumber(){
    console.log('Get Plain phone number', this.phoneNumber);
    
    if(this.phoneNumber){
      let ph = this.phoneNumber.replace(/[\s()-]/g, '')
      return '+1' + ph.substring(0,10)
    }
    return "";
  }

  getPlainPhoneNumberFromString(phoneNumber:string){
    let ph = phoneNumber.replace(/[\s()-]/g, '')
    return '+1' + ph.substring(0,10)
  }

  getFormattedPhoneNumber(phoneNumber){
    return phoneNumber.replace(/^(\+1)(\d{0,3})(\d{0,3})(\d{0,4})/, '($2) $3-$4')
  }


  refreshOrder(){
    this.isLoading = true
    this.orderService.getOrder(this.orderHash, this.isPosOnline).subscribe(
      data => {
        this.orderWithPayment = Object.assign(new OrdersWithPayment(), data, {
          bot_order: Object.assign(new BotOrder(), data.bot_order, {
            occasion_schedule: data.bot_order.occasion_schedule
              ? moment(data.bot_order.occasion_schedule, 'hh:mm A MMM DD, YYYY').toDate()
              : null
          }),
          items: data.items.map(o => Object.assign(new Order(), o, {
            modifiers: o.modifiers.map(x  => Object.assign(new Modifier(), x, {
              modifier: Object.assign(new ModifierOption(), x.modifier)
            }))
          })),
          store: Object.assign(new Store(), data.store),
          payment: OrderHelpers.parsePayment(data.payment)
        });
        this.store = this.orderWithPayment.store;
        this.isLoading = false;
        this.populateOrderName();
        this.cdr.markForCheck();
    })
  }

  verifyWorldnetCard() {
    this.isVerifyingCard = true;
    this.cdr.markForCheck();

    this.paymentGatewayService.verifyCard(this.orderHash).subscribe(
      (result: any) => {
        this.isVerifyingCard = false;
        if (result.verified) {
          this.snackBar.open('Card verified successfully', '', {
            duration: 3000, verticalPosition: 'top'
          });
          this.orderService.getLastPreferredPayment(this.orderHash, this.getPlainPhoneNumber(), this.paymentGateway).subscribe(
            (data: any) => {
              if (data['guest_payment_detail']) {
                const cardDetail = Object.assign(new CardDetails(), data['guest_payment_detail']);
                this.paymentOption = new PaymentOption(data['is_cash'], true, data['is_store_credit'], cardDetail, data['store_credit']);
                this.paymentOptionService.updatePaymentOption(this.paymentOption);
              }
              this.refreshOrder();
              this.cdr.markForCheck();
            },
            () => {
              this.refreshOrder();
              this.cdr.markForCheck();
            }
          );
        } else {
          const msg = result.error || 'Address verification failed. Please check your billing address and try again.';
          this.snackBar.open(msg, 'OK', {
            verticalPosition: 'top', duration: 8000
          });
          this.billingStreet = '';
          this.billingCity = '';
          this.billingZip = '';
          this.addressError = '';
          this.showBillingAddressForm = true;
          this.refreshOrder();
        }
        this.cdr.markForCheck();
      },
      (error) => {
        this.isVerifyingCard = false;
        const msg = error.error?.error || 'Address verification failed. Please update your billing address or use a different card.';
        this.snackBar.open(msg, 'OK', {
          verticalPosition: 'top', duration: 8000
        });
        this.billingStreet = '';
        this.billingCity = '';
        this.billingZip = '';
        this.addressError = '';
        this.showBillingAddressForm = true;
        this.refreshOrder();
        this.cdr.markForCheck();
      }
    );
  }

  submitBillingAddress() {
    if (!this.billingStreet.trim() || !this.billingCity.trim() || !this.billingZip.trim()) {
      this.addressError = 'All billing address fields are required.';
      this.cdr.markForCheck();
      return;
    }
    this.showBillingAddressForm = false;
    this.cdr.markForCheck();

    this.paymentGatewayService.updateBillingAddress(
      this.orderHash, this.billingStreet.trim(), this.billingCity.trim(), this.billingZip.trim()
    ).subscribe(() => {
      this.verifyWorldnetCard();
    }, () => {
      this.snackBar.open('Failed to save billing address. Please try again.', 'OK', {
        verticalPosition: 'top', duration: 5000
      });
      this.cdr.markForCheck();
    });
  }

  skipBillingAddress() {
    this.showBillingAddressForm = false;
    localStorage.removeItem('pending_worldnet_card_added');
    this.cdr.markForCheck();
  }

  resetPayment(){
    this.paymentOptionService.current.pipe(takeUntil(this.destroySubject)).subscribe(paymentOption => {
      if(paymentOption){
        this.paymentOption = paymentOption;
      }else{
        this.paymentOption = new PaymentOption(false, false, false, null);
      }
    })
  }


  ngOnInit() {
    this.autoOpenWalletRequested = this.route.snapshot.queryParamMap.get('openWallet') === '1';
    this.futureOccasionSelected = false;
    this.isLoading = true
    this.orderHash = this.route.snapshot.paramMap.get('orderId');
    // ENG-5609: guest mode is a decision the guest already made for this order. Without restoring
    // it, a refresh locked the checkout again and they had to wait out the resend cooldown a
    // second time. Kept per order, so it does not leak into the next one.
    this.guestCheckout = this.readGuestCheckout();

    this.isAdmin = this.route.snapshot.queryParamMap.get("is_admin") === '1'

    this.route.queryParams.pipe(takeUntil(this.destroySubject)).subscribe(params => {
      this.isPosOnline = params['is_pos_online'];
    });

    this.refreshSubject.pipe(debounceTime(50), takeUntil(this.destroySubject)).subscribe(() => this.refreshOrder());

    this.paymentObs = this.paymentOptionService.current.subscribe(paymentOption =>{
      if(paymentOption){
        this.paymentOption = paymentOption;
        this.refreshSubject.next();
      }
    })

    this.occasionObs = this.occasionDetailService.current.subscribe(occasionDetail => {
      if(occasionDetail){
        this.occasionDetail = occasionDetail;
        this.orderWithPayment && this.orderWithPayment.setOccasionDetail(occasionDetail);
        this.refreshSubject.next();
      }
    })

    this.orderService.getOrder(this.orderHash, this.isPosOnline).subscribe(
      data => {
        this.orderWithPayment = Object.assign(new OrdersWithPayment(), data, {
          bot_order: Object.assign(new BotOrder(), data.bot_order, {
            occasion_schedule: data.bot_order.occasion_schedule
              ? moment(data.bot_order.occasion_schedule, 'hh:mm A MMM DD, YYYY').toDate()
              : null
          }),
          items: data.items.map(o => Object.assign(new Order(), o, {
            modifiers: o.modifiers.map(x  => Object.assign(new Modifier(), x))
          })),
          store: Object.assign(new Store(), data.store),
          payment: OrderHelpers.parsePayment(data.payment)
        });
        this.occasionDetail = this.orderWithPayment.getOccasionDetail();
        this.uiSetting = this.orderWithPayment.store.ui_settings;
        if(this.orderWithPayment.bot_order.is_expired){
          this.router.navigateByUrl(`/store/${this.orderWithPayment.store.url_slug}`);
        }else if(this.orderWithPayment.bot_order.is_submitted && !this.orderWithPayment.bot_order.is_payment_pending){
          this.router.navigate(['order', this.orderHash, 'status', 'success']);
        }else if(this.orderWithPayment.items.length === 0){
          if (this.orderWithPayment.bot_order.is_catering) {
            this.router.navigate(['order', this.orderHash, 'store', this.orderWithPayment.store.url_slug, 'catering'])
          } else {
            this.router.navigate(['order', this.orderHash, 'store', this.orderWithPayment.store.url_slug])
          }
        }

        this.store = this.orderWithPayment.store;
        this.paymentGateway = this.orderWithPayment.store.payment_gateway;
        this.storeId = this.orderWithPayment.store.id;
        this.analyticsService.trackEvent('view_cart', {
          cart_total: this.orderWithPayment.payment.total,
          item_count: this.orderWithPayment.items.length,
          store_id: this.storeId,
          store_name: this.store.store_name
        });

        // After redirect back from Worldnet, trigger AVS verification if enabled
        const pendingWorldnetCard = localStorage.getItem('pending_worldnet_card_added');
        if (pendingWorldnetCard) {
          const returnUrl = localStorage.getItem('worldnet_card_return_url');
          if (returnUrl) {
            // Card was added from wallet page — redirect back there, let wallet handle verification
            localStorage.removeItem('worldnet_card_return_url');
            this.router.navigateByUrl(returnUrl);
            return;
          }
          localStorage.removeItem('pending_worldnet_card_added');
          if (this.store?.isEnabled('worldnet_penny_verification')) {
            this.verifyWorldnetCard();
          }
        }

        if(!this.orderWithPayment.isTabOpen()){
          this.tableSideTab = 'CHECKOUT';
        }

        if(this.orderWithPayment.bot_order.phone_number){
          this.phoneNumber = this.getFormattedPhoneNumber(this.orderWithPayment.bot_order.phone_number);
        }

        let cachedInstruction = localStorage.getItem(this.orderHash+"order-instruction")
        if(cachedInstruction != null && this.orderWithPayment.bot_order.special_request != cachedInstruction){
          this.orderWithPayment.bot_order.special_request = cachedInstruction;
          this.orderInstruction = cachedInstruction
        }

        this.populateOrderName()

        // if(this.orderWithPayment.store.has_card_payment && this.orderWithPayment.payment.type!='CASH'){
        if(this.orderWithPayment.store.has_card_payment && !this.canUseSavedPaymentData){
          // ENG-5610: unverified, or checking out as a guest. Fetch nothing keyed on the number;
          // they choose a payment method for this order alone.
          this.clearPaymentSelection();
          this.isLoading = false;
          this.cdr.markForCheck();
          this.maybeAutoOpenWallet();
        } else if(this.orderWithPayment.store.has_card_payment){
          // A 404 from get_last_preferred_payment means this phone has no prior saved payment —
          // treat it as empty so forkJoin resolves and the page renders.
          const emptyPreferredPayment = { is_cash: false, is_store_credit: false, guest_payment_detail: null, store_credit: 0 };
          forkJoin({
            cards: this.orderService.getCards(this.storeId, this.getPlainPhoneNumber(), this.paymentGateway),
            payment: this.orderService.getLastPreferredPayment(this.orderHash, this.getPlainPhoneNumber(), this.paymentGateway).pipe(
              catchError(() => of(emptyPreferredPayment))
            )
          }).pipe(takeUntil(this.destroySubject)).subscribe(({ cards, payment }: any) => {
            this.storeCredit = cards['store_credit'];
            if(payment['is_store_credit'] == true) {
              this.paymentOption = new PaymentOption(payment['is_cash'], false, payment['is_store_credit'], null, payment['store_credit'])
              this.paymentOption.card = payment.guest_payment_detail ? true :false
              this.paymentOption.cardDetail = payment.guest_payment_detail ? payment.guest_payment_detail :null
            }else if(payment['guest_payment_detail'] && payment['is_store_credit'] == false){
              let cardDetail = Object.assign(new CardDetails(), payment['guest_payment_detail'])
              if (this.paymentGateway === 'WORLDNET' && this.store?.isEnabled('worldnet_penny_verification') && cardDetail.is_avs_verified !== true) {
                this.paymentOption = new PaymentOption(payment['is_cash'], false, payment['is_store_credit'], null, payment['store_credit'])
              } else {
                this.paymentOption = new PaymentOption(payment['is_cash'], true, payment['is_store_credit'], cardDetail, payment['store_credit'])
                this.refreshOrder()
              }
            }else{
              const defaultCard = this.pickDefaultSavedCard(cards ? cards['cards'] : []);
              if (defaultCard) {
                // Returning guest with a saved card but no remembered preference: preselect their
                // most recent usable card so checkout is one tap, and persist it for the submit.
                this.paymentOption = new PaymentOption(false, true, false, defaultCard, payment['store_credit'])
                this.persistPreferredCard(defaultCard);
              } else {
                this.paymentOption = new PaymentOption(payment['is_cash'], false, payment['is_store_credit'], null, payment['store_credit'])
              }
            }

            this.paymentOptionService.updatePaymentOption(this.paymentOption)
            this.isLoading = false;
            this.cdr.markForCheck();
            this.maybeAutoOpenWallet();
          },
          error => {
            if(this.orderWithPayment.bot_order.payment_type == 'STORE_CREDIT') {
              this.updatePaymentAsStoreCredit();
            } else {
              this.resetPayment()
            }
            this.isLoading = false;
            this.cdr.markForCheck();
          });

          /* IF STORE CREDIT IS CHOICE */
        } else if(this.orderWithPayment.bot_order.payment_type == 'STORE_CREDIT') {
          this.updatePaymentAsStoreCredit();
        } else{
          this.resetPayment();
          this.isLoading = false;
        }

        if(this.orderWithPayment.bot_order.occasion === 'DELIVERY'
        && this.orderWithPayment.store.delivery_minimum
        && (this.orderWithPayment.payment.sub_total + this.orderWithPayment.payment.store_credit) < this.orderWithPayment.store.delivery_minimum){
          this.snackBar.open(`Minimum order value for delivery is $${this.orderWithPayment.store.delivery_minimum}`, "OK", {
            verticalPosition: 'top'
          })
        }

        if(this.orderWithPayment.bot_order.phone_number_verified){
          // ENG-4418: Re-check block status on page load even when phone is already verified.
          // Without this, a blocked user with a cached phone number bypasses the OTP block check.
          const phone_number_check = this.getPlainPhoneNumber().replace(/\+/g, '');
          if (phone_number_check.length >= 10) {
            this.orderService.checkNumberBlocked(this.storeId, phone_number_check).subscribe((data: any) => {
              if (data.data === true) {
                this.orderWithPayment.bot_order.phone_number_verified = false;
                this.snackBar.open('Your phone number is blocked', 'OK', { verticalPosition: 'top' });
              }
            });
          }

          // Determine if bottom sheet should auto-open (single emit to prevent duplicates)
          let _shouldOpenSchedule = false;
          const _occ = this.orderWithPayment.bot_order.occasion;
          const _time = this.orderWithPayment.bot_order.time;
          const _storeOpen = this.orderWithPayment.store.isStoreOpened();
          const _hasFuture = this.orderWithPayment.store.canScheduleOrders();
          const _firstVisit = localStorage.getItem(`${this.orderWithPayment.bot_order.order_hash}_occasionInitial`) !== 'false';

          // Occasion-specific: missing required field
          if (_occ === 'TABLESIDE' && !this.orderWithPayment.bot_order.dine_in_table_number) {
            _shouldOpenSchedule = true;
          }
          if (_occ === 'CURBSIDE' && !this.orderWithPayment.bot_order.curbside_vehicle_id) {
            _shouldOpenSchedule = true;
          }
          if (_occ === 'DINE IN' && !this.orderWithPayment.bot_order.dine_in_table_number) {
            _shouldOpenSchedule = true;
          }
          if (_occ === 'DELIVERY' && !this.orderWithPayment.bot_order.delivery_address) {
            _shouldOpenSchedule = true;
          }

          // Curbside-only store fallback
          if (this.store.hasCurbsideOnly()
            && _occ === 'PICKUP'
            && !this.orderWithPayment.store.has_order_occasion_pickup) {
            this.orderWithPayment.bot_order.occasion = 'CURBSIDE';
            _shouldOpenSchedule = true;
          }

          // ENG-5344: Store closed or default time=LATER → need user to pick schedule
          if (_occ && _firstVisit && ((!_storeOpen && _hasFuture) || _time === 'LATER')) {
            _shouldOpenSchedule = true;
          }

          if (_shouldOpenSchedule) {
            this.boolService.emitFlag(new Flag('openSchedule', true))
          }
        }

        if(this.orderWithPayment && this.orderWithPayment.store && !this.orderWithPayment.store.isStoreOpened()){
          this.snackBar.open(this.displayStoreCloseMsg, "OK", {
            duration: 10000,
            verticalPosition: 'top'
          })
        }
        this.cdr.markForCheck();
      },
      err => {});

  }

  updatePaymentAsStoreCredit() {
    if (!this.canUseSavedPaymentData) {
      // ENG-5610: store credit needs a proved number. Leave the order without a payment method
      // rather than showing a balance that is not theirs to spend.
      this.clearPaymentSelection();
      this.isLoading = false;
      return;
    }
    this.orderService.getCards(this.storeId, this.getPlainPhoneNumber(), this.paymentGateway).subscribe((data:any) => {
    },(error) => {
      this.storeCredit = error.error.store_credit
      this.isLoading = false
    });
    this.paymentOption = new PaymentOption(false, false,true, null, this.storeCredit);
    this.paymentOptionService.updatePaymentOption(this.paymentOption);

    if (this.orderWithPayment.payment.total > 0)
    this.snackBar.open('Store credit value is not enough to cover the total order balance, Please select another payment option.', "OK", {
      verticalPosition: 'top'
    })
  }

  ngOnDestroy(){
    this.stopOtpHelpers();
    this.paymentObs.unsubscribe();
    this.occasionObs.unsubscribe();
    if (this.orderSubmitSub) {
      this.orderSubmitSub.unsubscribe();
    }
    // ENG-5252: leaving the page during the hold means the order is never
    // submitted — that is the designed behavior of delayed-submit mode.
    if (this.submitHoldInterval) {
      clearInterval(this.submitHoldInterval);
    }

    this.destroySubject.next();
  }

  populateOrderName(){
    let cachedOrderName = localStorage.getItem(this.orderHash+"order-name")
    if(cachedOrderName != null && this.orderWithPayment.bot_order.order_name != cachedOrderName){
      this.orderWithPayment.bot_order.order_name = cachedOrderName;
      this.orderName = cachedOrderName
    }else{
      this.orderWithPayment.bot_order.order_name = localStorage.getItem("orderName");
      this.orderName = localStorage.getItem("orderName");
    }
  }

  checkLastPreferredPayment(){
    if (!this.canUseSavedPaymentData) return;   // ENG-5610: a typed number proves nothing
    if(this.getPlainPhoneNumber().length === 12){
      this.orderService.getLastPreferredPayment(this.orderHash, this.getPlainPhoneNumber(), this.paymentGateway).subscribe(data => {
        if(!data['guest_payment_detail'] && !data['is_cash'] && !data['is_store_credit']){
          this.paymentOption = new PaymentOption(false, false, false, null, data['store_credit'] || 0)
          this.paymentOptionService.updatePaymentOption(this.paymentOption)
          return;
        }
        if(!data['is_cash'] || !data['is_store_credit']){
          let cardDetail = Object.assign(new CardDetails(), data['guest_payment_detail'])
          if (this.paymentGateway === 'WORLDNET' && this.store?.isEnabled('worldnet_penny_verification') && cardDetail && cardDetail.is_avs_verified !== true) {
            this.paymentOption = new PaymentOption(false, false, false, null, data['store_credit'])
          } else {
            this.paymentOption = new PaymentOption(false, true, false, cardDetail, data['store_credit'])
            this.refreshOrder()
          }
          this.paymentOptionService.updatePaymentOption(this.paymentOption)
        }
      }, () => {
        this.paymentOption = new PaymentOption(false, false, false, null, 0)
      })
    }
  }

  /**
   * ENG-5612: this used to text the code the moment the tenth digit was typed. One wrong digit and
   * a stranger got the message — and we paid for it. The code now goes out when Verify is pressed;
   * this only keeps the order's contact number in step with what is on screen.
   */
  updatePhoneNumber(phoneNumber:string){
    const plainPhoneNumber = this.getPlainPhoneNumberFromString(phoneNumber);
    if (plainPhoneNumber.length !== 12 || this.otpSent || this.otpSending) return;
    this.orderService.updatePhoneNumber(this.orderHash, plainPhoneNumber)
      .subscribe(() => {}, () => {});
  }

  goBack(){
    if (this.orderWithPayment.bot_order.is_catering) {
      this.router.navigate(['order', this.orderHash, 'store', this.orderWithPayment.store.url_slug, 'catering'])
    } else {
      this.router.navigate(['order', this.orderHash, 'store', this.orderWithPayment.store.url_slug])
    }
  }

  cvvDialog(){
    let dialogRef = this.dialog.open(CvvDialogComponent, {height: '350px'})
    dialogRef.afterClosed().subscribe(data => {
      if(data){
        console.log(data);
      }
    })
  }

  getMaxLength(card: CardDetails){
    const isAmex = card.card_type.toLowerCase() === 'amex' || card.card_type.toLowerCase() === 'american express';
    return isAmex ? 4 : 3;
  }

  hasError(){
    return !this.orderWithPayment.bot_order.occasion || !this.paymentOption?.hasPaymentOption() || !this.isValidCVV();
  }
  getHelpErrors(){
    if(!this.orderWithPayment.bot_order.occasion){
      return "Select Order Type";
    }else if(!this.paymentOption?.hasPaymentOption()){
      return "Select Payment Method";
    }else if(!this.isValidCVV()){
      return "Enter CVV number";
    }
  }

  threeDsOrSubmit(){
    if(this.store.isEnabled("3DS")){
      let dialogRef = this.dialog.open(ThreedsCheckComponent, {
          data: {
            nameOnCard: this.paymentOption.cardDetail.name_on_card,
            customerVaultId: this.paymentOption.cardDetail.nmi_customer_vault_id,
            total: this.orderWithPayment.payment.total,
            gatewayId: this.store.nmi_public_key
          },
        disableClose: true,
        panelClass: ['full-screen-modal']
      });

      dialogRef.afterClosed().subscribe(data => {
        this.tdsResponse = data;
        if(data){
          this.onSubmit();
        }
      });
    }else{
      this.onSubmit();
    }
  }

  onSubmit(futureOrder: boolean = false) {

    if (this.isSubmitting) return;
    // Worldnet's hosted payment page redirects off-site and back, which starts a new PostHog
    // session — so begin_checkout and purchase land in different sessions and a session-based
    // funnel silently loses them. order_hash is the same on both, so join the funnel on that.
    this.analyticsService.trackEvent('begin_checkout', {
      order_hash: this.orderHash,
      cart_total: this.orderWithPayment.payment.total,
      item_count: this.orderWithPayment.items.length,
      payment_method: this.paymentOption?.cash ? 'cash' : 'card',
      occasion: this.orderWithPayment.bot_order.occasion,
      store_id: this.storeId,
      is_future_order: futureOrder
    });

    // ENG-5614: the delivery minimum used to sit in the else-if below, so a wallet payment was the
    // one way to place a delivery order under the store's minimum.
    if(this.orderWithPayment.bot_order.occasion === 'DELIVERY'
        && this.orderWithPayment.store.delivery_minimum
        && (this.orderWithPayment.payment.sub_total + this.orderWithPayment.payment.store_credit) < this.orderWithPayment.store.delivery_minimum){
      this.snackBar.open(`Minimum order value for delivery is $${this.orderWithPayment.store.delivery_minimum}`, "OK", {
        verticalPosition: 'top'
      });
      this.inputRange.value = '0';
      return;
    }

    if(this.paymentOption.mobilePaymentService){
      // ENG-5580: the Worldnet branch left the button enabled for the whole round-trip, so a
      // second tap fired a second submission and the gateway rejected it as DUPLICATE_REQUEST.
      this.isSubmitting = true;
      this.cdr.markForCheck();
      // ENG-5614: the order name and instructions were never saved on this path — the browser
      // left for the gateway and the order came back closed without them, so the kitchen ticket
      // was missing whatever the guest typed.
      this.orderService
        .updateOrderInstructions(this.orderHash, this.orderInstruction, this.orderName)
        .subscribe(() => this.redirectToHostedPaymentPage(),
                   () => this.redirectToHostedPaymentPage());
      return;
    }

    {
      // ENG-5252: when the store enables customer cancellation, instant orders
      // wait out the cancel window client-side BEFORE any submit API call.
      // Cancelling during the hold means nothing was ever sent to the store.
      if (!futureOrder && !this.submitHoldActive && this.canDelaySubmit()) {
        this.startSubmitHold(futureOrder);
        return;
      }
      this.executeSubmitCore(futureOrder);
    }
  }

  /** ENG-5614: Worldnet's hosted payment page. Called once the order's own details are saved. */
  private redirectToHostedPaymentPage() {
    this.paymentGatewayService
      .getHPPUrlGA(+this.store.id, `${this.orderWithPayment.bot_order.id}`,
                   this.orderWithPayment.payment.total, this.orderName)
      .subscribe((data: any) => {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = "https://payments.worldnettps.com/merchant/paymentpage";
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = data[key];
            form.appendChild(hiddenField);
          }
        }
        document.body.appendChild(form);
        this.leavingForPaymentPage = true;
        form.submit();
      }, err => {
        // The backend refuses a payment page for an unverified order or a tampered amount, and
        // 504s when the gateway cannot be reached. Say so rather than leaving a dead button.
        this.isSubmitting = false;
        this.analyticsService.captureException(err, { step: 'worldnet_hpp_url', order_hash: this.orderHash });
        const message = err?.error?.error || 'We could not start the payment. Please try again.';
        this.snackBar.open(message, 'OK', { duration: 4000, verticalPosition: 'top' });
        this.cdr.markForCheck();
      });
  }

  canDelaySubmit(): boolean {
    const settings: any = this.store && this.store['customer_order_cancel'];
    return !!(settings && settings.enabled && (settings.window_seconds || 60) > 0);
  }

  startSubmitHold(futureOrder: boolean) {
    const settings: any = this.store['customer_order_cancel'] || {};
    this.pendingHoldFutureOrder = futureOrder;
    this.submitHoldSeconds = settings.window_seconds || 60;
    this.submitHoldActive = true;
    this.submitHoldInterval = setInterval(() => {
      this.submitHoldSeconds--;
      if (this.submitHoldSeconds <= 0) {
        this.finishSubmitHold(true);
      }
      // OnPush component: repaint the countdown every tick.
      this.cdr.markForCheck();
    }, 1000);
    this.cdr.markForCheck();
  }

  private finishSubmitHold(placeOrder: boolean) {
    if (this.submitHoldInterval) {
      clearInterval(this.submitHoldInterval);
      this.submitHoldInterval = null;
    }
    this.submitHoldActive = false;
    this.submitHoldSeconds = 0;
    this.cdr.markForCheck();
    if (placeOrder) {
      this.executeSubmitCore(this.pendingHoldFutureOrder);
    }
  }

  submitHoldPlaceNow() {
    this.finishSubmitHold(true);
  }

  cancelSubmitHold() {
    this.finishSubmitHold(false);
    this.snackBar.open('Your order was cancelled and has not been placed.', 'OK', {
      verticalPosition: 'top'
    });
  }

  private executeSubmitCore(futureOrder: boolean) {
      this.isSubmitting = true;

      var obs = null
      if (this.orderWithPayment.bot_order.occasion === 'TABLESIDE'
        || (this.store.enable_pos_pay_later && this.paymentOption.cash)){
        const payload = {
          'cash_total': this.orderWithPayment.payment.cash_due_total,
        }
        obs = this.orderService.payLater(this.orderHash, payload, futureOrder);
      } else {
        obs = this.orderService.submitOrder(this.orderHash, this.optIn, futureOrder, this.cvv, this.tdsResponse).pipe(takeUntil(this.destroySubject))
      }
      // updateOrderInstructions used to be called twice, nested, and neither call had an error
      // handler: any failure here left isSubmitting stuck at true, so the customer sat on the
      // "submitting" spinner forever with no message and the order was never sent.
      this.orderService
        .updateOrderInstructions(this.orderHash, this.orderInstruction, this.orderName).pipe(takeUntil(this.destroySubject))
        .subscribe(
          () => {
            this.orderSubmitSubject.next('');
            if (this.orderSubmitSub) {
              this.orderSubmitSub.unsubscribe();
            }
            this.orderSubmitSub = this.orderSubmitSubject.pipe(debounceTime(500)).subscribe(() => {
              obs.subscribe(
                (success) => {
                  localStorage.removeItem('menu_group_name');
                  localStorage.removeItem('menu_sub_group_name');
                  this.isSubmitting = false;
                  this.router.navigate(['order', this.orderHash, 'status', 'success']);
                },
                (error) => {
                  this.isSubmitting = false;
                  if (error.status === 403) {
                    if (error.error?.error === 'This customer is blocked from ordering.') {
                      this.snackBar.open('Your phone number is blocked', 'OK', { verticalPosition: 'top' });
                    } else {
                      this.router.navigate(['order', this.orderHash, 'status', 'suspicious']);
                    }
                  } else {
                    this.router.navigate(['order', this.orderHash, 'status', 'failure']);
                  }
                }
              );
            });
          },
          (error) => {
            this.isSubmitting = false;
            this.cdr.markForCheck();
            this.analyticsService.captureException(error, { step: 'update_order_instructions', order_hash: this.orderHash });
            this.snackBar.open('We could not save your order details. Please try again.', 'OK', { verticalPosition: 'top' });
          }
        );
  }

  instructionChange(inst:string){
    localStorage.setItem(this.orderHash+"order-instruction", inst)
    this.orderInstruction = inst;
  }

  orderNameChange(name:string){
    localStorage.setItem(this.orderHash+"order-name", name)
    this.orderName = name;
  }

  addCard(){
    this.isLoading = true;
    this.guestCardDetails = [];
    this.orderService.getCards(this.storeId, this.getPlainPhoneNumber(), this.paymentGateway).subscribe(data => {
      this.guestCardDetails = data['cards'].map(o => Object.assign(new CardDetails(), o));
      this.storeCredit = data['store_credit']
      this.isLoading = false;
    },
    (error) => {
      this.guestCardDetails = []
      this.storeCredit = error.error.store_credit
      this.isLoading = false
    }).add(()=>{
      this.bottomSheet.open(PaymentMethodsBottomSheetComponent, {
        panelClass: 'payment-bottom-sheet-container',
        disableClose: !this.paymentOption.hasPaymentOption(),
        data:  {
          orderHash: this.orderWithPayment.bot_order.order_hash,
          phoneNumber: this.orderWithPayment.bot_order.phone_number,
          orderTotal: this.orderWithPayment.getOriginalTotal(),
          storeCredit: this.storeCredit,
          cardDetails: this.guestCardDetails,
          paymentGateway: this.orderWithPayment.store.payment_gateway,
          storeId: this.orderWithPayment.store.id,
          parent: this,
          storeCreditEnabled: true,
          storeCashEnabled: this.store.enable_cash_payment,
          storeCardEnabled: this.store.has_card_payment,
          paymentOption: this.paymentOption,
          surcharge: this.store.surcharge_percent,
          payrocUsername: this.store.payroc_username,
          nmiPublicKey: this.store.nmi_public_key,
          store: this.store
        }
      }).afterDismissed().subscribe(data => {
        if(data){
          this.paymentOption = data.paymentOption
          this.paymentOptionService.updatePaymentOption(data.paymentOption)
          this.isLoading = false;
        }
      });
    });
  }

  sendOTP(){
    if(this.otpSending || this.resendCooldown > 0) return;
    // Pressing Verify is a decision to verify after all. The code field is hidden in guest mode,
    // so without leaving guest mode here the code arrives and there is nowhere to type it — the
    // guest is stuck on that order for good. They can choose guest again after the next resend.
    if (this.guestCheckout) {
      this.guestCheckout = false;
      this.writeGuestCheckout(false);
    }
    this.otpSending = true;
    const plainNumber = this.getPlainPhoneNumber();
    const phone_number_check = plainNumber.replace(/\+/g, '');
    this.orderService.checkNumberBlocked(this.storeId, phone_number_check).subscribe((data:any) => {
      if (data.data == false) {
        this.orderService.otp(this.orderHash, this.getPlainPhoneNumber()).subscribe((res: any) => {
          // ENG-5612: this number was already verified on this order, so no code was sent.
          // Showing the code field here left the guest waiting on a text that never arrives.
          if (res?.is_verified) {
            this.otpSending = false;
            this.otpSent = false;
            this.orderWithPayment.bot_order.phone_number_verified = true;
            this.orderWithPayment.bot_order.phone_number = this.getPlainPhoneNumber();
            this.stopOtpHelpers();
            this.cdr.markForCheck();
            return;
          }
          const resend = this.otpSent;
          this.onOtpSent();
          if (resend) {
            this.snackBar.open('A new code is on its way', 'OK', { duration: 2500, verticalPosition: 'top' });
          }
        }, err => {
          this.otpSending = false;
          // ENG-5612: the backend caps sends per number and per IP and answers 429 with a reason.
          // Showing it stops the guest hammering Resend against a limit they cannot see.
          const message = err?.error?.error || 'Could not send the code. Please try again.';
          this.snackBar.open(message, 'OK', { duration: 4000, verticalPosition: 'top' });
          this.cdr.markForCheck();
        })
      } else {
        this.otpSending = false;
        this.snackBar.open('Your phone number is blocked', "OK", {
          verticalPosition: 'top'
        })
      }
    }, () => { this.otpSending = false; });

  }

  verifyOTP(){
    const plainNumber = this.getPlainPhoneNumber();
    const phone_number_check = plainNumber.replace(/\+/g, '');
    this.orderService.checkNumberBlocked(this.storeId, phone_number_check).subscribe((data:any) => {
      if (data.data == false) {
        // Send a number when the code is digits-only: the current backend compares against an
        // integer column, so this keeps verification working even if the frontend ships first.
        const otpValue: string | number = /^\d+$/.test(String(this.otp || '')) ? Number(this.otp) : this.otp;
        this.orderService.verifyOtp(this.orderHash, this.getPlainPhoneNumber(), otpValue).subscribe(data => {
          this.stopOtpHelpers();
          localStorage.setItem(Constants.PHONE_NUMBER_KEY, this.getPlainPhoneNumber())
          // ENG-5610: the server issues this once the number is proved. The interceptor sends it
          // back as X-Device-Token, so a returning guest is recognised by something the server
          // gave out rather than by a number the browser asserts.
          if (data['device_token']) {
            try {
              localStorage.setItem(DEVICE_TOKEN_KEY, data['device_token']);
            } catch (e) {
              // storage blocked: the guest verifies again next time, nothing breaks
            }
          }
          this.analyticsService.identifyUser(null, this.getPlainPhoneNumber());
          this.orderWithPayment.bot_order.phone_number_verified = data['is_verified'];
          this.orderWithPayment.bot_order.phone_number = this.getPlainPhoneNumber();
          this.orderService
            .getLastPreferredPayment(this.orderHash,
              this.getPlainPhoneNumber(),
              this.paymentGateway).subscribe(data => {
                this.isLoading = false;
              if(!data['guest_payment_detail'] && !data['is_cash'] && !data['is_store_credit']){
                this.paymentOption = new PaymentOption(false, false, false, null, data['store_credit'] || 0)
                this.paymentOptionService.updatePaymentOption(this.paymentOption)
                this.preselectSavedCardIfAny(data['store_credit'] || 0);
                this.boolService.emitFlag(new Flag('openSchedule', true))
                this.cdr.markForCheck();
                return;
              }
              const cardDetail = Object.assign(new CardDetails(), data['guest_payment_detail'])
              if (this.paymentGateway === 'WORLDNET' && this.store?.isEnabled('worldnet_penny_verification') && cardDetail && cardDetail.is_avs_verified !== true) {
                this.paymentOption = new PaymentOption(data['is_cash'], false, data['is_store_credit'], null, data['store_credit'])
              } else {
                this.paymentOption = new PaymentOption(data['is_cash'], true, data['is_store_credit'], cardDetail, data['store_credit'])
              }
              this.paymentOptionService.updatePaymentOption(this.paymentOption)
              this.boolService.emitFlag(new Flag('openSchedule', true))
              this.cdr.markForCheck();
          }, error=> {
            this.paymentOption = new PaymentOption(false, false, false, null)
            this.paymentOptionService.updatePaymentOption(this.paymentOption)
            this.cdr.markForCheck();
          })
          this.refreshOrder()
        }, err => {
          // ENG-5612: a wrong, expired or exhausted code used to fail silently, so the guest
          // retyped the same thing. The backend now sends a reason; show it.
          const message = err?.error?.error || 'That code is incorrect. Please check it and try again.';
          this.snackBar.open(message, 'OK', { duration: 4000, verticalPosition: 'top' });
          this.cdr.markForCheck();
        })
      } else {
        this.snackBar.open('Your phone number is blocked', "OK", {
          verticalPosition: 'top'
        })
      }
    });
  }

  changePhone(){
    this.orderWithPayment.bot_order.phone_number_verified = false;
    // The card on screen was remembered for the number they are leaving. Drop it, or it stays
    // selected under a number nobody has proved. Verifying the new number brings one back.
    this.clearPaymentSelection();
    this.otpSent = false;
    this.otpSending = false;
    this.otp = '';
    this.guestCheckout = false;
    this.writeGuestCheckout(false);
    this.stopOtpHelpers();
  }

  /**
   * The last number this browser actually verified, when it is not the one being entered now.
   *
   * Someone who changed their number and cannot receive the new code has not lost the old one —
   * the device token still proves it. Offering it back is better than pushing them into guest
   * mode, where they would give up saved cards, rewards and store credit they are entitled to.
   */
  get previousVerifiedNumber(): string {
    let stored: string = null;
    try {
      stored = localStorage.getItem(Constants.PHONE_NUMBER_KEY);
    } catch (e) {
      return null;
    }
    if (!stored || stored === this.getPlainPhoneNumber()) return null;
    return stored;
  }

  /** (555) 123-4567 from +15551234567, for showing on the button. */
  get previousVerifiedNumberDisplay(): string {
    const n = this.previousVerifiedNumber;
    if (!n) return '';
    const d = n.replace(/\D/g, '').slice(-10);
    return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : n;
  }

  /**
   * Go back to the number this browser already proved. The server recognises the device token and
   * verifies it without texting a code, so this is instant and costs nothing.
   */
  useVerifiedNumber() {
    const previous = this.previousVerifiedNumber;
    if (!previous) return;
    this.phoneNumber = previous;
    this.guestCheckout = false;
    this.writeGuestCheckout(false);
    this.otpSent = false;
    this.otp = '';
    this.orderService.updatePhoneNumber(this.orderHash, previous).subscribe(() => {
      this.sendOTP();
    }, () => {
      this.sendOTP();
    });
  }

  /**
   * ENG-5609. Offered only once the guest has actually waited out a resend, so it is a way past a
   * code that never arrives rather than a way around verifying at all.
   */
  get canOfferGuestCheckout(): boolean {
    return !!this.store?.allow_guest_checkout
      && this.guestHasAPaymentRoute
      && this.otpSent
      && this.resendCooldown === 0
      && !this.guestCheckout
      && !this.orderWithPayment?.bot_order?.phone_number_verified;
  }

  /**
   * A guest may pay with cash, or on the gateway's hosted page. The hosted page is Worldnet's -
   * redirectToHostedPaymentPage() posts to payments.worldnettps.com - so at a store on any other
   * gateway a guest has no way to pay at all. Offering guest checkout there walked them past
   * verification and then stranded them with no payment method, which is worse than not
   * offering it. Mirrors submit_allowed() in order/views.py, which accepts exactly these two.
   */
  private get guestHasAPaymentRoute(): boolean {
    return !!this.store?.enable_cash_payment
      || (!!this.store?.has_card_payment && this.store?.payment_gateway === 'WORLDNET');
  }

  /**
   * ENG-5610: may this browser use what belongs to the number on the order?
   *
   * Saved cards, store credit and the remembered payment method are all keyed on a phone number
   * and nothing else, so without this the page fetched and pre-selected a stranger's card as soon
   * as their number was on screen — typed by hand, or simply restored from the last order on a
   * shared tablet. Mirrors guest_data_allowed() in order/device_tokens.py; the server applies the
   * same rule once TRUST_BROWSER_PHONE_NUMBER is off.
   */
  get canUseSavedPaymentData(): boolean {
    return !this.guestCheckout
      && !!this.orderWithPayment?.bot_order?.phone_number_verified;
  }

  /** Nothing of the number's is in play: empty the selection rather than leave a stale card. */
  private clearPaymentSelection() {
    this.storeCredit = 0;
    this.paymentOption = new PaymentOption(false, false, false, null, 0);
    this.paymentOptionService.updatePaymentOption(this.paymentOption);
  }

  /**
   * Unverified checkout: the phone number stays on the order as a contact number, but nothing
   * belonging to that number is reachable. The guest pays with a card entered for this order,
   * which the backend will not save.
   */
  private guestCheckoutKey(): string {
    return `guest_checkout:${this.orderHash}`;
  }

  private readGuestCheckout(): boolean {
    try {
      return localStorage.getItem(this.guestCheckoutKey()) === '1';
    } catch (e) {
      return false;   // private window or blocked storage: they choose again
    }
  }

  private writeGuestCheckout(on: boolean) {
    try {
      if (on) {
        localStorage.setItem(this.guestCheckoutKey(), '1');
      } else {
        localStorage.removeItem(this.guestCheckoutKey());
      }
    } catch (e) {
      // storage blocked: guest mode still works for this page view
    }
  }

  continueAsGuest() {
    this.guestCheckout = true;
    this.writeGuestCheckout(true);
    this.otpSent = false;
    this.otp = '';
    this.stopOtpHelpers();
    this.paymentOption = new PaymentOption(false, false, false, null, 0);
    this.paymentOptionService.updatePaymentOption(this.paymentOption);
    this.snackBar.open('Continuing as a guest. You can pay by card on this order.', 'OK',
      { duration: 4000, verticalPosition: 'top' });
    // Verifying opens the occasion picker as the next step. A guest reaches the same point by a
    // different route, so it has to be opened here too or the order stalls with no order type.
    this.boolService.emitFlag(new Flag('openSchedule', true));
    this.cdr.markForCheck();
  }

  /** Code was texted: show the field and start the resend cooldown. */
  private onOtpSent() {
    this.otpSent = true;
    this.otpSending = false;
    this.startResendCooldown();
    this.cdr.markForCheck();
  }

  private startResendCooldown() {
    this.clearResendCooldown();
    this.resendCooldown = OrderSummaryMasterComponent.RESEND_COOLDOWN_S;
    this.resendTimer = setInterval(() => {
      this.resendCooldown = Math.max(0, this.resendCooldown - 1);
      if (this.resendCooldown === 0) this.clearResendCooldown();
      this.cdr.markForCheck();
    }, 1000);
  }

  private clearResendCooldown() {
    if (this.resendTimer) { clearInterval(this.resendTimer); this.resendTimer = null; }
    this.resendCooldown = 0;
  }

  // The WebOTP listener lived here. It only ever resolves for a message carrying the origin-bound
  // "@<origin> #<code>" line, and ENG-5617 removed that line because Android flagged the message
  // as possible spam and a merchant escalated it. Keeping the listener would have been dead code
  // that reads like working autofill. The input still has autocomplete="one-time-code", which iOS
  // and Android fill from the message text on their own and does not depend on that format.

  private stopOtpHelpers() {
    this.clearResendCooldown();
  }

  /** Most recently used saved card that can be charged right now, or null. */
  private pickDefaultSavedCard(cards: any[]): CardDetails | null {
    const avsRequired = this.paymentGateway === 'WORLDNET' && this.store?.isEnabled('worldnet_penny_verification');
    const usable = (cards || [])
      .map(c => Object.assign(new CardDetails(), c))
      .filter(c => !c.is_deleted && !c.hasExpired() && (!avsRequired || c.is_avs_verified === true))
      .sort((a, b) => new Date(b.updated_at || b.created_at || 0).getTime() - new Date(a.updated_at || a.created_at || 0).getTime());
    return usable[0] || null;
  }

  private persistPreferredCard(card: CardDetails) {
    const payload = { is_cash: false, is_card: true, is_store_credit: false, guest_payment_id: card.id };
    this.orderService.updatePreferredPayment(this.orderHash, payload).subscribe(() => this.refreshOrder(), () => {});
  }

  /** After OTP: nothing remembered for this phone, but there may be saved cards to fall back on. */
  private preselectSavedCardIfAny(storeCredit: number) {
    this.orderService.getCards(this.storeId, this.getPlainPhoneNumber(), this.paymentGateway).subscribe((wallet: any) => {
      const card = this.pickDefaultSavedCard(wallet ? wallet['cards'] : []);
      if (!card) return;
      this.paymentOption = new PaymentOption(false, true, false, card, storeCredit);
      this.paymentOptionService.updatePaymentOption(this.paymentOption);
      this.persistPreferredCard(card);
      this.cdr.markForCheck();
    }, () => {});
  }

  private maybeAutoOpenWallet() {
    if (!this.autoOpenWalletRequested) return;
    this.autoOpenWalletRequested = false;
    this.router.navigate([], { relativeTo: this.route, queryParams: { openWallet: null }, queryParamsHandling: 'merge', replaceUrl: true });
    setTimeout(() => this.openWallet(), 0);
  }

  deleteCard(card:CardDetails){
    this.orderService.deleteCard(card).subscribe(() => {
      let index = this.guestCardDetails.indexOf(card, 1)
      if(index > -1){
        this.guestCardDetails.splice(index, 1)
      }
      this.checkLastPreferredPayment()
    })
  }

  isValidOccasion(occasion){
    let closingTime = this.store.getClosingHours();
    let buffer = +this.store.last_order_buffer[occasion];
    if(buffer > 0){
      let updated = moment(closingTime).subtract(buffer, 'minutes').toDate();
      return moment().toDate() < updated;
    }else{
      return true;
    }
  }

  setPromoCodeValidation(event){
    this.promoConditionsMet = event;
  }

  isValidCVV(){
    if(!this.store.isEnabled('CVV_CHECK') || !this.paymentOption.card){
      return true;
    }
    return this.cvv && this.cvv.length > 2;
  }

  isValid(keepPaymentCheck = false){
    const hasNumber = this.getPlainPhoneNumber() != "" && this.getPlainPhoneNumber().length === 12;
    // A method counts only when it can actually be charged: a card needs its saved detail and
    // cash needs the store to accept cash. Guarding here (not only in the template) is what stops
    // a null-card order from being submitted and falling through to "cash" on the backend.
    const po = this.paymentOption;
    // ENG-5609: what a guest may pay with. Mirrors submit_allowed() in order/views.py — a card
    // entered for this order, the gateway's hosted page, or cash where the store takes cash.
    // Store credit is absent on purpose: it belongs to a number nobody has proved.
    const guestPaymentCheck = !!po && (
      po.mobilePaymentService ||
      (po.card && !!po.cardDetail) ||
      (po.cash && !!this.store?.enable_cash_payment)
    );
    let paymentCheck = guestPaymentCheck || (!!po && po.storeCredit);
    // In guest mode the number is a contact number, not proof: the order is valid only when it
    // pays one of the ways above. Checking only for a card left Apple Pay / Google Pay and cash
    // guests with a Submit button that never enabled.
    let phoneCheck = hasNumber
      && (this.orderWithPayment.bot_order.phone_number_verified || (this.guestCheckout && guestPaymentCheck))
    //override paymentCheck if we don't need payment method to be selectes(show_menu_price is N/A)

    if(keepPaymentCheck){
      paymentCheck = true;
    }
    let validOccasion = this.orderWithPayment.bot_order.occasion && this.isValidOccasion(this.orderWithPayment.bot_order.occasion)
    let validAvailability;
    const activeItems = this.orderWithPayment.items.filter(i => !i.is_removed);
    if (activeItems.length > 0) {
      validAvailability = activeItems.map(i => {
        if(i.menu_item.available_qty !== null){
          return i.menu_item.available_qty > 0;
        }else return true;
      }).reduce((l,r) => l && r)
    }

    /* CHECK STORE CREDIT IS SUFFICIENT OR NOT */
    let validStoreCredit = this.orderWithPayment.bot_order.payment_type == 'STORE_CREDIT' && this.orderWithPayment.payment.total > 0;

    return !this.isSubmitting && phoneCheck && paymentCheck && this.orderWithPayment.isValidOrder()
      && this.orderName && validOccasion && this.promoConditionsMet && validAvailability && !validStoreCredit;
  }

  hasItemToSubmit(){
    return this.orderWithPayment.items.filter(i => !i.ts_submitted).length > 0
      || this.orderWithPayment.misc_items.filter(i => !i.ts_submitted).length > 0
  }

  hasPlacedTablesideOrder(){
    return this.orderWithPayment.items.filter(i => i.ts_submitted).length > 0
  }

  submitTablesideOpenTab(){
    this.isLoading = true;
    let oi = this.orderService.updateOrderInstructions(this.orderHash, this.orderInstruction, this.orderName)
    oi.subscribe(data => {
      this.orderService.submitTablesideOpenTab(this.orderHash).subscribe(data => {
        this.ngOnInit()
      }, error =>{
        this.router.navigate(['order', this.orderHash, 'status', 'failure']);
      })
    })
  }

  closeTableSide(){
    const dialogRef = this.dialog.open(ArrivedDialogComponent, {
      width: '350px',
      data:{
        confirmText: 'Yes',
        message: 'Ready to close your tab?',
        parking:0,
      }
    });

    dialogRef.afterClosed().subscribe(data => {
      if(data){
        this.checkoutTableSide();
      }else{
        this.tableSideTab = 'OPENTAB';
      }
    });
  }

  checkoutTableSide(){
    let oi = this.orderService.updateOrderInstructions(this.orderHash, this.orderInstruction, this.orderName)
    oi.subscribe(data => {
      this.orderService.submitTablesideConfirm(this.orderHash, this.optIn).subscribe(
        () => {
          this.router.navigate(['order', this.orderHash, 'status', 'success']);
        },
        () => {
          this.router.navigate(['order', this.orderHash, 'status', 'failure']);
        })
    })
  }

  isFutureOrderEnabled(){
    return this.store.isEnabled(Constants.FUTURE_ORDER);
  }

  openBottomSheet(): void {
    this.occasionDetail = this.orderWithPayment.getOccasionDetail();
    let bsRef = this.bottomSheet.open(ScheduleBottomSheetComponent, {
      panelClass: 'schedule-bottom-sheet-container',
      disableClose: localStorage.getItem(`${this.orderWithPayment.bot_order.order_hash}_occasionInitial`) !== 'false',
      data: {
        orderWithPayment: this.orderWithPayment,
        paymentOption: this.paymentOption,
        occasionDetail: this.occasionDetail,
        hasPlacedTablesideOrder: this.hasPlacedTablesideOrder(),
      }
    });

    bsRef.backdropClick().subscribe(event => {
      this.occasionDetail = this.orderWithPayment.getOccasionDetail();
      this.futureOccasionSelected = true;
    })

    bsRef.afterDismissed().subscribe(occasionDetail => {
      this.futureOccasionSelected = true;
      if(occasionDetail !== 'cancel'){
        this.occasionDetailService.updateOccasionDetail(occasionDetail);
      }else{
        this.occasionDetail = this.orderWithPayment.getOccasionDetail();
      }
    })
  }

  /* SLIDE TO SUBMIT FEATURE */
  moveDot(changes: SimpleChanges, value:any): void{
    this.inputRange = document.getElementsByClassName('pullee')[0] as HTMLInputElement;
    this.inputRange.min = '0';
    this.inputRange.max = this.maxValue.toString();
    this.inputRange.addEventListener('mousedown', this.unlockStartHandler.bind(this), false);
    this.inputRange.addEventListener('mouseup', this.unlockEndHandler.bind(this), false);
    this.inputRange.addEventListener('touchend', this.unlockEndHandler.bind(this), false);
    this.inputID = value;
  }

  unlockStartHandler() {
    window.cancelAnimationFrame(this.rafID);
    this.currValue = +this.inputRange.value;
  }

  unlockEndHandler() {
    this.currValue = +this.inputRange.value;
    if (this.currValue >= this.maxValue) {
      this.successHandler();

    } else {
      this.rafID = window.requestAnimationFrame(this.animateHandler.bind(this));
    }
  }

  animateHandler() {
    this.inputRange.value = this.currValue.toString();
    if (this.currValue > -1) {
      window.requestAnimationFrame(this.animateHandler.bind(this));
    }
    this.currValue = this.currValue - this.speed;
  }

  successHandler() {
    if (this.inputID == 'cash_card') {
      this.onSubmit()
    } else if (this.inputID == 'table_open') {
      this.submitTablesideOpenTab();
    } else if (this.inputID =='table_checkout') {
      this.checkoutTableSide();
    }
    // alert('Success')
    this.inputRange.value = '0';
  }

  openWallet(){
    // Open the wallet against the order as it is. The old flow first nulled the server-side
    // preferred payment, so dismissing the wallet left the order payment-less and a later Pay
    // fell through to "cash" (disabled at many stores → blank failure page).
    const dialogRef = this.dialog.open(WalletComponent, {
      disableClose: true,
      data:  {order: this.orderWithPayment, selectMode: true, guestCheckout: this.guestCheckout},
      panelClass: ['full-screen-modal']
    });
    dialogRef.afterClosed().subscribe(data => {
      if (!data) return;
      if (data.action === 'verify_card') {
        const card = data.card;
        const verifyPayload = {
          is_cash: false, is_card: true, is_store_credit: false,
          guest_payment_id: card.id
        };
        this.orderService.updatePreferredPayment(this.orderHash, verifyPayload).subscribe(() => {
          this.verifyWorldnetCard();
        }, () => {
          this.verifyWorldnetCard();
        });
        return;
      }
      this.paymentOption = data;
      this.isLoading = true;
      let payload = {
        is_cash: data.cash, is_card: data.card, is_store_credit: data.storeCredit,
        guest_payment_id: data.cardDetail ? data.cardDetail.id : null,
        // ENG-5609: "Pay by card" and Apple/Google Pay both close the wallet with
        // mobilePaymentService set and no card of their own - the card is entered on the
        // gateway's hosted page. Without this the order was saved with every method false, so
        // the server had no idea how it was going to be paid: submit_allowed() in
        // order/views.py reads is_mobile_payment_service to recognise the hosted-page route,
        // and refused the payment page for a guest who had in fact chosen one.
        is_mobile_payment_service: !!data.mobilePaymentService
      }
      this.orderService.updatePreferredPayment(this.orderHash, payload).subscribe(data => {
        this.isLoading = false;
        this.refreshOrder();
      }, () => {
        this.isLoading = false;
        this.refreshOrder();
      });
    });
  }

  deliveryCondition(orderWithPayment) {
    const { bot_order, payment, store } = orderWithPayment; // Destructuring for easier access to properties
    const isDeliveryOrder = bot_order?.occasion === 'DELIVERY';
    const hasDeliveryMinimum = store.delivery_minimum;
    const totalPayment = payment.sub_total + payment.store_credit;
    const meetsDeliveryMinimum = totalPayment < store.delivery_minimum;

    // Directly return the evaluation result of all conditions
    return isDeliveryOrder && hasDeliveryMinimum && meetsDeliveryMinimum;
  }

  getPaymentOptionType(paymentOption: any): string {
    if (paymentOption?.storeCredit && !paymentOption?.cash && !paymentOption?.cardDetail) {
      return 'storeCredit';
    }
    if (paymentOption?.cash && !paymentOption?.cardDetail) {
      return 'cash';
    }
    if (paymentOption?.cardDetail && paymentOption?.cardDetail.id) {
      return 'card';
    }
    if(paymentOption?.mobilePaymentService){
      return 'mobilePaymentService';
    }
    return 'default';
  }


  scheduleOrder(){
    const dialogRef = this.dialog.open(ScheduleOrderDialogComponent,
      {
        width: '350px',
        data: {
          order: this.orderWithPayment,
        }
      });
    dialogRef.afterClosed().subscribe(data => {
      this.ngOnInit()
    });
  }


}
